export const ManfrediteContractTypeValues = ['EMPLOYED', 'SELF_EMPLOYED'];
//# sourceMappingURL=manfredite-contract-type.js.map